import React from 'react'

function FormHeader() {
    return (
        <>
            <div className='opk-login-wordmark w-100 wordmark-align'>
                <img src='/images/openknots-form-header.svg' alt='Openknots Form Header' className='ms-4' />
            </div>

        </>
    )
}

export default FormHeader